import Ordinance from './Ordinance'

export default class InitiatoryOrdinance extends Ordinance {
  constructor(initiatory, t) {
    super({
      data: initiatory,
      title: t('wcf.person-ordinances.initiatory', 'Initiatory'),
      t,
    })
  }
}
